import { useQuery } from "@tanstack/react-query";
import { getAllTimeReports, getMonthlyReport } from "../api/reports";
import type AllTimeReports from "../models/finance/AllTimeReports";
import type ReportDTO from "../models/finance/Reports";
import { formatBackendDate } from "../utils/DateUtil";

export const reportKeys = {
  all: ["reports"] as const,
  allTime: ["reports", "allTime"] as const,
  monthly: (start: Date, end: Date) =>
    ["reports", "monthly", formatBackendDate(start), formatBackendDate(end)] as const,
};

export function useAllTimeReports() {
  return useQuery({
    queryKey: reportKeys.allTime,
    queryFn: (): Promise<AllTimeReports> => getAllTimeReports(),
    staleTime: 5 * 60_000,
  });
}

export function useMonthlyReport(start: Date, end: Date) {
  return useQuery({
    queryKey: reportKeys.monthly(start, end),
    queryFn: (): Promise<ReportDTO> => getMonthlyReport(start, end),
    enabled: !!start && !!end,
    staleTime: 60_000,
  });
}


